'use client';

import { useFetcherCSR } from '@/lib/useFetcherCSR';
import Link from 'next/link';
import { useState } from 'react';
import OrderUpdateModal from './OrderUpdateModal';
import axios from '@/lib/axios';
import { toast } from 'react-toastify';

interface Order {
  id: string;
  date: string;
  status: string;
  total: string;
  update: string;
  action: string;
}

const MyOrders = () => {
  const { data: purchaseHistory, mutate } = useFetcherCSR(
    '/api/v2/purchase-history'
  );
  const [showModal, setShowModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState<any>(null);

  const handleSubmit = async (data: any) => {
    setShowModal(false);

    try {
      const res = await axios.post(
        `/api/v2/order/shipping-update/${selectedOrder?.id}`,
        data
      );
      if (res?.data?.result) {
        toast.success(res.data.message);
        setSelectedOrder(res?.data?.date);
        mutate();
      } else {
        toast.error(res.data.message);
      }
    } catch (error: any) {
      toast.error(error.message || 'update failed');
    }
  };

  const handleOpenModal = (order: any) => {
    setSelectedOrder(order);
    setShowModal(true);
  };

  const getInitialValues = () => {
    if (!selectedOrder) return {};

    return {
      shipping_name: selectedOrder.shipping_address?.name || '',
      shipping_phone: selectedOrder.shipping_address?.phone || '',
      shipping_area_id: selectedOrder.shipping_address?.area_id || '',
      shipping_city_id: selectedOrder.shipping_address?.city_id || '',
      shipping_zone_id: selectedOrder.shipping_address?.zone_id || '',
      shipping_address: selectedOrder.shipping_address?.address || '',
    };
  };

  return (
    <>
      <div className="dashboard__content">
        <div className="dashboard__content-header">
          <h5>My Orders</h5>
        </div>

        <div className="dashboard__content-info">
          <div className="dashboard__content-details customer-order">
            <div className="row">
              <div className="col-12">
                <div className="customer-order__table-wrapper table-responsive">
                  <table className="customer-order__table table">
                    <thead className="customer-order__thead">
                      <tr>
                        <th>#Order</th>
                        <th>Date</th>
                        <th>Status</th>
                        <th>Total</th>
                        <th>Update</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    {purchaseHistory?.data?.length > 0 ? (
                      <tbody className="customer-order__tbody">
                        {purchaseHistory?.data?.map(
                          (order: any, index: number) => (
                            <tr key={index}>
                              <td>{order.id}</td>
                              <td>{order.date}</td>
                              <td>{order.delivery_status_string}</td>
                              <td>{order.grand_total}</td>
                              <td>
                                <button
                                  onClick={() => handleOpenModal(order)}
                                  className="trk-btn trk-btn--outline trk-btn--md"
                                >
                                  Update info
                                </button>
                              </td>
                              <td>
                                <Link
                                  className="customer-order__link"
                                  href={`/order-details/${order.id}`}
                                >
                                  {' '}
                                  <button className="trk-btn trk-btn--outline trk-btn--md">
                                    Order Details
                                  </button>
                                </Link>
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                    ) : (
                      <tbody className="customer-order__tbody">
                        <tr>
                          <td className="text-center" colSpan={6}>
                            There is no Product yet
                          </td>
                        </tr>
                      </tbody>
                    )}
                  </table>
                  {/* <div className="text-center">
                  <Link href={'/shop'}>
                    {' '}
                    <button className="trk-btn trk-btn--primary">
                      Shop Now
                    </button>
                  </Link>
                </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <OrderUpdateModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        onSubmit={handleSubmit}
        initialValues={getInitialValues()}
      />
    </>
  );
};

export default MyOrders;
